module.exports = __webpack_public_path__ + "img/1726037201888-screenshot-1726037181196.png.fff8c20f.webp";